<template lang="en">
  <link rel="stylesheet" href="../CSS/App.css">
  <div>
    <header>
      <div class="mobile-top">
        <div class="mobile-items">
          <div class="logo"> <a role="button" @click="sendTo('/')"><img alt="Goldstar logo, leads back to homepage." style="width: 100%;" :data-column="'img1'" :src=BranchPage.img1></a></div>
          <img @click="showMenu()" class="hamburger" style="width: 40px;" src="../assets/Hamburger_icon.svg">
        </div>
      </div>
      <div id="mobile-menu" class="mobile-menu">
        <p class="find-me">‎‎‎‎‎‎‎‎</p>
        <div class="mobile-divider" @click="sendTo('/about')">
        <a role="button" @click="sendTo('/about')" class="mobile-options" :data-column="'menu1'">{{ BranchPage.menu1 }}</a></div>
        <div class="mobile-divider" @click="sendTo('/find-loan')" ><a role="button" @click="sendTo('/find-loan')" class="mobile-options" :data-column="'menu2_1'">{{ BranchPage.menu2_1 }}</a></div>
        <div class="mobile-divider" @click="sendTo('/process')"><a role="button" @click="sendTo('/process')" class="mobile-options" :data-column="'menu2_2'">{{ BranchPage.menu2_2 }}</a></div>
        <div class="mobile-divider" @click="sendTo('/calculators')"><a @click="sendTo('/calculators')" class="mobile-options" :data-column="'menu3'">{{ BranchPage.menu3_1 }}</a></div>
        <div class="mobile-divider" @click="sendTo('/careers')"><a @click="sendTo('/careers')" class="mobile-options" :data-column="'menu4'">{{ BranchPage.menu4 }}</a></div>
        <div class="mobile-divider" @click="sendTo('/locations')"><a role="button" @click="sendTo('/locations')" class="mobile-options" :data-column="'menu4'">Branches</a></div>
        <div class="mobile-divider" @click="sendTo('/divisions')"><a role="button" @click="sendTo('/divisions')" class="mobile-options" :data-column="'menu4'">Divisions</a></div>
        <div class="mobile-divider" @click="sendTo('/vetlife')"><a role="button" @click="sendTo('/vetlife')" class="mobile-options" :data-column="'menu4'">VetLife</a></div>
        <div v-if="orgid != 'HQ'" class="mobile-divider" role="button" @click="sendTo('/loan-officers')"><a @click="sendTo('/loan-officers')" class="mobile-options" :data-column="'menu5'">{{ BranchPage.menu5 }}</a></div>
      </div>
      <div class="page_top">
        <div class="logo"> <a role="button" aria-label="Leads back to home page." @click="sendTo('')"><img alt="Goldstar Logo" style="width: 100%;" :data-column="'img1'" :src=BranchPage.img1></a></div>
        <nav class="menu-buttons">
          <div class="dropdown">
            <div @click="sendTo('/about')" class="menu-area">
              <a role="button" :data-column="'menu1'">{{ BranchPage.menu1 }}
                <i class="fa fa-caret-down"></i>
              </a>
            </div>
            <div class="dropdown-content">
              <a role="button" @click="sendToAnchor('/about', '#Mission')" :data-column="'menu1_2'">{{ BranchPage.menu1_2 }}</a>
              <a role="button" @click="sendToAnchor('/about', '#Leadership')" :data-column="'menu1_3'">{{ BranchPage.menu1_3 }}</a>
              <a role="button" @click="sendToAnchor('/about', '#Pillars')" :data-column="'menu1_4'">{{ BranchPage.menu1_4 }}</a>
            </div>
          </div>
          <div class="dropdown">
            <div class="menu-area">
              <a role="button" :data-column="'menu2'">{{ BranchPage.menu2 }}
                <i class="fa fa-caret-down"></i>
              </a>
            </div>
            <div class="dropdown-content">
              <a role="button" @click="sendTo('/find-loan')" :data-column="'menu2_1'">{{ BranchPage.menu2_1 }}</a>
              <a role="button" @click="sendTo('/process')" :data-column="'menu2_2'">{{ BranchPage.menu2_2 }}</a>
            </div>
          </div>
          <div @click="sendTo('/calculators')" class="menu-area">
            <a role="button" @click="sendTo('/calculators')" :data-column="'menu3'">{{ BranchPage.menu3_1 }}</a>
          </div>
          <div @click="sendTo('/careers')" class="menu-area">
            <a role="button" @click="sendTo('/careers')" :data-column="'menu4'">{{ BranchPage.menu4 }}</a>
          </div>
          <div v-if="orgid != 'HQ'" @click="sendTo('/loan-officers')" class="menu-area">
            <a role="button" @click="sendTo('/loan-officers')" :data-column="'menu5'">{{ BranchPage.menu5 }}</a>
          </div>
          <div class="dropdown">
            <div class="menu-area">
              <a role="button" :data-column="'menu2'">Locations
                <i class="fa fa-caret-down"></i>
              </a>
            </div>
            <div class="dropdown-content">
              <a role="button" @click="sendTo('/locations')" :data-column="'menu4'">Branches</a>
              <a role="button" @click="sendTo('/divisions')" :data-column="'menu2_2'">Divisions</a>
            </div>
          </div>
        </nav>
        <div class="apply">
          <div class="phone-class"><img role="none" alt="Phone image" style="width: 20px; height: 20px; margin-right: 20px; margin-top: 6%;"
              src="https://cdn-icons-png.flaticon.com/128/483/483947.png"><a class="phone-number"
              href="tel:800-201-5626">1-800-201-LOAN(5626)</a></div>
            <KButton role="button" @click="openWindow('https://payment.goldstarfinancial.com/')" :size="null" :class="'custom-size3'" :theme-color="'null'"
              style="border-radius: 40px; height: 40px; width: 180px; position: fixed; top: 4%; box-shadow: 10 black; box-shadow: 2px 5px 5px 0px rgba(0,0,0,0.2);">
              <span style="font-size: large; font-weight: bold">Make a Payment</span></KButton>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';
import { Button as KButton } from "@progress/kendo-vue-buttons";
import apiService from '../api/api.service';
var check = 0;

export default {
  components: {
    KButton,
  },

  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,

    };
    
  },

  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else if(url != '')
        window.location.href = url;
      else
        window.location.href = '/';
    },
    openWindow(url){
      window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    },
    sendToAnchor(url1, url2) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url1 + '/?org=' + searchParams.get('org') +url2;
      }
      else
        window.location.href = url1 + url2;
    },
    showMenu(){
      if(check == 0){
        document.getElementById('mobile-menu').style.bottom = "-10%";
        check = 1;
      }
      else{
        document.getElementById('mobile-menu').style.bottom = "100%";
        check = 0;
      }
      console.log("help");
    }
  }
};
</script>

<style scoped>
@import '/src/assets/css/header.css';
</style>